import React, { useEffect, useRef, useState } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "./CoachFeedback.scss";
import "videojs-markers/dist/videojs.markers.css";
import "videojs-markers";
import { useSelector } from "react-redux";
import { getCoachFeedback } from "../../redux/network/coachAPI";
import { Stage, Layer, Rect } from "react-konva";

/* Suppress videojs deprecation warning

const originalWarn = console.warn;

console.warn = (...args) => {

  if (args[0] && typeof args[0] === 'string' && args[0].includes('videojs.plugin() is deprecated')) {

    return; // Suppress this specific warning

  }

  originalWarn.apply(console, args);

};*/
export default function CoachFeedback({ videoId }) {
  const env = process.env.REACT_APP_ENV;
  const videoRef = useRef(null);
  const [player, setPlayer] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [videoDimensions, setVideoDimensions] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [annotationData, setAnnotationData] = useState([]);
  const [activeComments, setActiveComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const videoContent = useSelector((state) => state.video.videoContent);
  const jwtToken = localStorage.getItem("BQS_TOKEN");
  const userId = localStorage.getItem("BQS__ID");
  const [displayDialogBoxForNewAIFeedbacks, setDisplayDialogBoxForNewAIFeedbacks] =
    useState(false);

  //standAloneFeedback
  const standAloneFeedbacks = useSelector(state => state.standAlone.feedbacks.feedbackData);
  console.log("standAloneFeedbacks", standAloneFeedbacks)


  useEffect(() => {
    if (videoRef.current) {
      setVideoDimensions({
        width: videoRef.current.clientWidth,
        height: videoRef.current.clientHeight,
      });
    }
  }, [videoRef.current?.clientWidth, videoRef.current?.clientHeight]);

  useEffect(() => {
    if (env !== "standalone") {
      const fetchAnnotations = async () => {
        try {
          const response = await getCoachFeedback(jwtToken, videoId);
          const data = response.data.feedbacks || [];
          let areNewAiFeedbacksPresent = response?.data?.areNewAiFeedbacksPresent;
          if (areNewAiFeedbacksPresent === true)
            setDisplayDialogBoxForNewAIFeedbacks(areNewAiFeedbacksPresent);

          setDisplayDialogBoxForNewAIFeedbacks(response?.data?.areNewAiFeedbacksPresent);
          setAnnotationData(data || []);
          setLoading(false);
        } catch (err) {
          setError(err.message);
          setLoading(false);
        }
      };
      fetchAnnotations();
    } else {
      const standaloneVideoFeedback = standAloneFeedbacks.find((feedback) => feedback._id === videoId)
      console.log("standaloneVideoFeedback", standaloneVideoFeedback)
      console.log("standaloneVideoFeedback feedback", standaloneVideoFeedback.feedback)

      setAnnotationData(standaloneVideoFeedback.feedback || []);
      setLoading(false);
    }
  }, [env, jwtToken]);

  useEffect(() => {
    if (videoRef.current && annotationData.length > 0) {
      const vjsPlayer = videojs(videoRef.current, {
        controls: true,
        autoplay: false,
        preload: "auto",
      });

      // Initialize markers
      vjsPlayer?.markers({
        markers: annotationData.map((annotation) => ({
          time: annotation.timeRange.startTime,
          text: "Annotation " + annotation.timeRange.startTime,
        })),
        markerStyle: {
          width: "5px",
          backgroundColor: "red",
        },
        onMarkerReached: (marker) => {
          vjsPlayer?.pause();
          // Adjust annotations when a marker is reached
          setCurrentTime(marker.time);

          // Resume playback after 10 seconds
          setTimeout(() => {
            vjsPlayer?.play();
          }, 4000);
        },
      });

      setPlayer(vjsPlayer);

      const timeInterval = setInterval(() => {
        setCurrentTime(vjsPlayer.currentTime());
      }, 4000); // Update every second

      return () => {
        clearInterval(timeInterval);
        if (vjsPlayer) {
          vjsPlayer?.dispose();
        }
      };
    }
  }, [videoRef, annotationData]);

  useEffect(() => {
    const relevantComments = annotationData
      .filter(
        (annotation) =>
          currentTime >= annotation.timeRange.startTime &&
          currentTime <= annotation.timeRange.endTime
      )
      .map((annotation) => annotation.comments)
      .flat();

    setActiveComments(relevantComments || []);
  }, [currentTime, annotationData]);

  // Convert annotation data to Konva shapes (rectangles)
  const getAnnotationsForCurrentTime = () => {
    return annotationData.filter(
      (annotation) =>
        currentTime >= annotation.timeRange.startTime &&
        currentTime <= annotation.timeRange.endTime
    );
  };

  // Map annotations to Konva Rectangles
  const drawAnnotations = () => {
    const annotations = getAnnotationsForCurrentTime();
    return annotations.map((annotation, index) => {
      const { coordinates } = annotation.markerDetails;
      return (
        <Rect
          key={index}
          x={coordinates.x1}
          y={coordinates.y1}
          width={coordinates.x2 - coordinates.x1}
          height={coordinates.y2 - coordinates.y1}
          fill="rgba(255, 0, 0, 0.3)"
          stroke="red"
          strokeWidth={2}
          draggable
        />
      );
    });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const handleVideoEnd = () => {
    setIsPaused(false); // Set paused to false when the video ends
  };
  const dataFormatter = (dateString) => {
    const inputDate = new Date(dateString);

    const monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];


    const day = inputDate.getDate();
    const monthIndex = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const hours = inputDate.getHours();
    const minutes = inputDate.getMinutes();

    return `${day} ${monthNames[monthIndex]} ${year} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }
  const reviewPost = JSON.parse(localStorage.getItem("reviewPost"))

  return (
    <section>



      <h1>Feedback video</h1>


      <p >{dataFormatter(reviewPost.updatedAt)}</p>

      <div className="coach-feedback" style={{ position: "relative", display: "grid", gridTemplateColumns: "2fr 1fr", gap: "1rem", margin: "1rem" }}>
        <div >
          <div style={{ width: "600px", height: "400px", borderRadius: "10px", overflow: "hidden" }}>

            <div className="w-full h-full relative">
              <video
                ref={videoRef}
                className="video-js vjs-default-skin w-full h-full"
                controls
                onEnded={handleVideoEnd}
              >
                <source
                  src={env === "standalone" ? "/banner_video.mp4" : videoContent.videoContentUrl}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>

              {/* Konva overlay */}
              <Stage
                width={videoDimensions.width}
                height={videoDimensions.height}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  pointerEvents: isPaused ? "auto" : "none",
                  zIndex: 1,
                }}
              >
                <Layer>{drawAnnotations()}</Layer>
              </Stage>
            </div>
          </div>
        </div>

        {/* Feedback Column */}
        <div className="comments-container" style={{ overflowY: 'auto', maxHeight: '400px', padding: '1rem', background: '#D9F0DE', borderRadius: '10px' }}>
          {activeComments.length > 0 ? (
            activeComments.map((comment, index) => (
              <div key={index} style={{ background: 'rgba(255,255,255,0.5)', borderRadius: '8px', padding: '12px', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', fontSize: '12px', marginRight: '8px' }}>
                    {comment.metaData.userName.charAt(0).toUpperCase()}
                  </div>
                  <span style={{ fontWeight: 'bold', textTransform: 'capitalize', fontSize: '14px' }}>{comment.metaData.userName}</span>
                </div>
                <div style={{ background: 'rgba(255,255,255,0.8)', padding: '12px', borderRadius: '8px', fontSize: '14px', color: '#374151', marginBottom: '8px' }}>
                  {comment.body}
                </div>
                <div style={{ textAlign: 'right', fontSize: '12px', color: '#9ca3af' }}>
                  {new Date(comment.metaData.dateTime).toLocaleString()}
                </div>
              </div>
            ))
          ) : (
            <div style={{ color: '#6b7280', textAlign: 'center', padding: '40px 0', fontStyle: 'italic' }}>No comments at this time.</div>
          )}
        </div>
      </div>
    </section>
  );
}

